import {
    Box,
    Typography,
    Avatar,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Pagination,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import DummyUser from "../../Assets/User.webp";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Loader from "../../Components/Loader";

const Feedbacks = () => {
    const pageSize = 5;
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [feedbackData, setFeedbackData] = useState([]);
    const [totalData, setTotalData] = useState(0);
    const [useDummyData, setUseDummyData] = useState(false);

    // Dummy fallback data
    const dummyData = [
        {
            id: 1,
            user: {
                id: 1,
                name: "John Doe",
                email: "john.doe@example.com",
                image: null,
            },
            questions: [
                {
                    question: "How would you rate your overall experience?",
                    answer: "Excellent! The app is very user-friendly and intuitive.",
                },
                {
                    question: "What features do you use most frequently?",
                    answer: "I mainly use the walk tracking and social feed features.",
                },
                {
                    question: "What improvements would you suggest?",
                    answer: "It would be great to have more customization options for the profile.",
                },
                {
                    question: "Would you recommend this app to others?",
                    answer: "Absolutely! I've already recommended it to several friends.",
                },
            ],
            created_at: "2024-01-15 10:30:00",
        },
        {
            id: 2,
            user: {
                id: 2,
                name: "Jane Smith",
                email: "jane.smith@example.com",
                image: null,
            },
            questions: [
                {
                    question: "How would you rate your overall experience?",
                    answer: "Very good, but there's room for improvement.",
                },
                {
                    question: "What features do you use most frequently?",
                    answer: "The community features and pet profiles are my favorites.",
                },
                {
                    question: "What improvements would you suggest?",
                    answer: "Better notification management and dark mode support.",
                },
                {
                    question: "Would you recommend this app to others?",
                    answer: "Yes, especially to pet owners who love staying active.",
                },
                {
                    question: "Any additional comments?",
                    answer: "Keep up the great work! Looking forward to future updates.",
                },
            ],
            created_at: "2024-01-14 15:45:00",
        },
    ];

    const getFeedbackList = async () => {
        setLoading(true);
        try {
            const count = (page - 1) * pageSize;
            const params = {
               
                count,
                limit: pageSize,
         
            };
            const response = await AxiosInstance.get(ApiList.FEEDBACKS, params);
            if (response?.data?.s === 1 && response?.data?.r?.length > 0) {
                setFeedbackData(response?.data?.r);
                setUseDummyData(false);
                if (params.skip === 0) {
                    const totalCount = response?.data?.total || 0;
                    localStorage.setItem("feedbackTotalCount", totalCount);
                    setTotalData(totalCount);
                } else {
                    const totalCountFromStorage = localStorage.getItem("feedbackTotalCount");
                    setTotalData(totalCountFromStorage ? Number(totalCountFromStorage) : 0);
                }
            } else {
                // Use dummy data if no data from API
                setUseDummyData(true);
                const start = (page - 1) * pageSize;
                const end = start + pageSize;
                setFeedbackData(dummyData.slice(start, end));
                setTotalData(dummyData.length);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching feedback data:", error);
            // Use dummy data on error
            setUseDummyData(true);
            const start = (page - 1) * pageSize;
            const end = start + pageSize;
            setFeedbackData(dummyData.slice(start, end));
            setTotalData(dummyData.length);
            setLoading(false);
        }
    };

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        getFeedbackList();
    }, [page]);

    return (
        <Box
            sx={{
                width: "100%",
                height: "100vh",
                background: "#B9CC0310",
                overflow: "hidden",
            }}
        >
            <Box sx={{ width: "100%", p: 2, background: "#B9CC0310" }}>
                <Typography
                    sx={{
                        fontSize: { xs: "18px", md: "28px" },
                        fontWeight: "300",
                        color: "#000",
                    }}
                >
                    Feedbacks
                </Typography>
            </Box>
            <Box sx={{ width: "100%", height: "calc(100vh - 74px)" }}>
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        p: 2,
                        overflow: "auto",
                    }}
                >
                    {loading ? (
                        <Box
                            sx={{
                                width: "100%",
                                height: "400px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Loader />
                        </Box>
                    ) : feedbackData.length === 0 ? (
                        <Box
                            sx={{
                                width: "100%",
                                height: "400px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <Typography sx={{ color: "#FFFFFF60", fontSize: "18px" }}>
                                No feedback data available
                            </Typography>
                        </Box>
                    ) : (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pb: 2 }}>
                            {feedbackData.map((feedback, index) => {
                                return (
                                    <Accordion
                                        key={feedback.id || index}
                                        defaultExpanded
                                        sx={{
                                            background: "#fff",
                                            borderRadius: "10px !important",
                                            border: "1px solid #FFFFFF10",
                                            "&:before": {
                                                display: "none",
                                            },
                                            "&.Mui-expanded": {
                                                margin: "0 !important",
                                            },
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: "#c6ff00" }} />}
                                            sx={{
                                                minHeight: "70px !important",
                                                "&.Mui-expanded": {
                                                    minHeight: "70px !important",
                                                },
                                                "& .MuiAccordionSummary-content": {
                                                    margin: "12px 0 !important",
                                                },
                                            }}
                                        >
                                            {/* User Info Header */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    width: "100%",
                                                    pr: 2,
                                                }}
                                            >
                                                <Avatar
                                                    sx={{
                                                        width: 50,
                                                        height: 50,
                                                        border: "2px solid #c6ff00",
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            feedback?.user_image
                                                                ? `${ApiList?.IMG_URL}${feedback.user_image}`
                                                                : DummyUser
                                                        }
                                                        alt={feedback?.fname || "User"}
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </Avatar>
                                                <Box sx={{ flex: 1 }}>
                                                    <Typography
                                                        sx={{
                                                            color: "#000",
                                                            fontSize: "18px",
                                                            fontWeight: "500",
                                                        }}
                                                    >
                                                        {feedback?.fname || "Anonymous User"}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            color: "#000",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {feedback?.email || "No email provided"}
                                                    </Typography>
                                                </Box>
                                                {feedback?.feedbacks?.[0]?.created_at && (
                                                    <Box sx={{ textAlign: "right" }}>
                                                        <Typography
                                                            sx={{
                                                                color: "#000",
                                                                fontSize: "13px",
                                                                fontWeight: "500",
                                                            }}
                                                        >
                                                            {new Date(
                                                                feedback.feedbacks[0].created_at
                                                            ).toLocaleDateString()}
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                color: "#000",
                                                                fontSize: "12px",
                                                            }}
                                                        >
                                                            {new Date(
                                                                feedback.feedbacks[0].created_at
                                                            ).toLocaleTimeString()}
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                        </AccordionSummary>

                                        <AccordionDetails sx={{ pt: 0, pb: 2, px: 2 }}>
                                            {/* Questions and Answers */}
                                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                                                {feedback?.feedbacks?.map((qa, qaIndex) => {
                                                    return (
                                                        <Accordion
                                                            key={qaIndex}
                                                            sx={{
                                                                background: "#b9cc0360",
                                                                borderRadius: "8px !important",
                                                                border: "none",
                                                                "&:before": {
                                                                    display: "none",
                                                                },
                                                                "&.Mui-expanded": {
                                                                    margin: "0 !important",
                                                                },
                                                            }}
                                                        >
                                                            <AccordionSummary
                                                                expandIcon={
                                                                    <ExpandMoreIcon sx={{ color: "#ff9100" }} />
                                                                }
                                                                sx={{
                                                                    minHeight: "48px !important",
                                                                    "&.Mui-expanded": {
                                                                        minHeight: "48px !important",
                                                                    },
                                                                    "& .MuiAccordionSummary-content": {
                                                                        margin: "12px 0 !important",
                                                                    },
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 1,
                                                                        width: "100%",
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            color: "#000",
                                                                            fontSize: "14px",
                                                                            fontWeight: "500",
                                                                        }}
                                                                    >
                                                                        Q{qa.question_number}.
                                                                    </Typography>
                                                                    <Typography
                                                                        sx={{
                                                                            color: "#000",
                                                                            fontSize: "14px",
                                                                            fontWeight: "400",
                                                                            flex: 1,
                                                                        }}
                                                                    >
                                                                        {qa.question_text || `Question ${qa.question_number}`}
                                                                    </Typography>
                                                                </Box>
                                                            </AccordionSummary>
                                                            <AccordionDetails
                                                                sx={{
                                                                    pt: 0,
                                                                    pb: 2,
                                                                    px: 2,
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        background: "#fff",
                                                                        borderRadius: "6px",
                                                                        p: 2,
                                                                        borderLeft: "3px solid #ff9100",
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            color: "#000",
                                                                            fontSize: "14px",
                                                                            lineHeight: 1.6,
                                                                            mb: 1.5,
                                                                        }}
                                                                    >
                                                                        {qa.answer_text}
                                                                    </Typography>
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            gap: 2,
                                                                            pt: 1.5,
                                                                            borderTop: "1px solid #FFFFFF20",
                                                                            flexWrap: "wrap",
                                                                        }}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                color: "#000",
                                                                                fontSize: "12px",
                                                                            }}
                                                                        >
                                                                            <strong>Created : </strong>{" "}
                                                                            {new Date(
                                                                                qa.created_at
                                                                            ).toLocaleString()}
                                                                        </Typography>
                                                                        <Typography
                                                                            sx={{
                                                                                color: "#000",
                                                                                fontSize: "12px",
                                                                            }}
                                                                        >
                                                                            <strong>User ID :</strong> {qa.user_id}
                                                                        </Typography>
                                                                        <Typography
                                                                            sx={{
                                                                                color: "#000",
                                                                                fontSize: "12px",
                                                                            }}
                                                                        >
                                                                            <strong>Survey ID :</strong>{" "}
                                                                            {qa.survey_id}
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                            </AccordionDetails>
                                                        </Accordion>
                                                    );
                                                })}
                                            </Box>
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })}

                            {/* Pagination */}
                            {totalData > pageSize && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        mt: 3,
                                        mb: 2,
                                    }}
                                >
                                    <Pagination
                                        count={Math.ceil(totalData / pageSize)}
                                        page={page}
                                        onChange={handlePageChange}
                                        sx={{
                                            "& .MuiPaginationItem-root": {
                                                color: "white",
                                                borderColor: "#FFFFFF30",
                                            },
                                            "& .MuiPaginationItem-root.Mui-selected": {
                                                background: "linear-gradient(91.18deg, #c6ff00 1.39%, #87E3FF 53.43%, #c6ff00 99.58%)",
                                                color: "black",
                                                fontWeight: "600",
                                            },
                                            "& .MuiPaginationItem-root:hover": {
                                                backgroundColor: "rgba(59, 198, 241, 0.1)",
                                            },
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default Feedbacks;